import React, { useState, useContext, useEffect, lazy, Suspense } from "react";
import { ThemeContext } from "./context";
import Navbar from "./components/navBar/navBar";
import ThemeToggle from "./components/themeToggle/ThemeToggle";
import Intro from "./components/intro/Intro";
import About from "./components/about/About";
import Skills from "./components/skills/Skills";
import Experience from "./components/experience/Experience";
import ProductList from "./components/productList/productList";
import MediumPosts from "./components/mediumPosts/MediumPosts";
import YouTubeVideos from "./components/youtubeVideo/youtubeVideo";
import Contact from "./components/contact/Contact";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import RoleBasedView from "./components/role-based/RoleBasedView";

const App = () => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;
    const [currentPage, setCurrentPage] = useState("home");
    const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

    // Check if user is already authenticated (session)
    useEffect(() => {
        const isAuthenticated = sessionStorage.getItem("adminAuthenticated") === "true";
        if (isAuthenticated) {
            setIsAdminAuthenticated(true);
        }

        // Handle /admin URL
        const handleRouteChange = () => {
            const path = window.location.pathname;
            if (path === "/admin" || path === "/admin/") {
                if (isAuthenticated) {
                    setCurrentPage("admin-dashboard");
                    setIsAdminAuthenticated(true);
                } else {
                    setCurrentPage("admin-login");
                }
            } else if (path === "/roles" || path === "/roles/") {
                setCurrentPage("role-based");
            } else {
                setCurrentPage("home");
            }
        };

        handleRouteChange();
        window.addEventListener("popstate", handleRouteChange);
        return () => window.removeEventListener("popstate", handleRouteChange);
    }, []);

    const handleAdminLogin = () => {
        setIsAdminAuthenticated(true);
        setCurrentPage("admin-dashboard");
        window.history.pushState(null, "", "/admin");
    };

    const handleAdminLogout = () => {
        sessionStorage.removeItem("adminAuthenticated");
        setIsAdminAuthenticated(false);
        setCurrentPage("home");
        window.history.pushState(null, "", "/");
    };

    // Render admin login page
    if (currentPage === "admin-login") {
        return (
            <div className={`${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-100 text-gray-900'} min-h-screen transition-colors duration-300`}>
                <AdminLogin onLoginSuccess={handleAdminLogin} />
            </div>
        );
    }

    // Render admin dashboard
    if (currentPage === "admin-dashboard" && isAdminAuthenticated) {
        return (
            <div className={`${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-100 text-gray-900'} min-h-screen transition-colors duration-300`}>
                <AdminDashboard onLogout={handleAdminLogout} />
            </div>
        );
    }

    // Render role-based view
    // if (currentPage === "role-based") {
    //     return (
    //         <div className={`${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-100 text-gray-900'} min-h-screen transition-colors duration-300`}>
    //             <RoleBasedView />
    //         </div>
    //     );
    // }

    // Render main portfolio
    return (
        <div className={`${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-white text-gray-900'} min-h-screen transition-colors duration-300`}> 
            <Navbar />
            <ThemeToggle />
            <div className="main-content pt-20">
                <Intro />
                <About />
                <ProductList />
                <Experience />
                <Skills />
                <MediumPosts />
                <YouTubeVideos />
                <Contact />
            </div>
        </div>
    );
};

export default App;
